<template>
    <ssn-modal></ssn-modal>
    <div id="section-block" class="page-blockui">
        <div class="row" id="credit_scores_step">
            <div class="col-xl-12 col-md-12 col-12 mx-auto">
                <power-of-attorney/>
            </div>
        </div>
    </div>
    <div class="card page-blockui">
        <div class="card-body">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <a
                        class="nav-link active"
                        id="clientDetail-tab"
                        data-toggle="tab"
                        href="#clientDetail"
                        aria-controls="home"
                        role="tab"
                        aria-selected="true"
                    >
                        <i data-feather="home"></i>
                        Client Details
                    </a>
                </li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane active" id="clientDetail" aria-labelledby="clientDetail-tab" role="tabpanel">
                    <div class="row match-height">
                        <div class="col-md-5 col-lg-5 col-sm-12">
                            <!-- Client Personal Information -->
                            <div class="card border-primary border-darken-1">
                                <div class="card-body">
                                    <div class="d-flex align-items-baseline justify-content-around">
                                        <h5 class="card-title mb-1">
                                            Payment Status:
                                        </h5>
                                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                            <label
                                                class="btn btn-outline-secondary"
                                                :class="{ active: userStore.user?.recurly_subscription_state == 'none' }"
                                            >
                                                <input
                                                    type="radio"
                                                    name="radio_options"
                                                    id="radio_option1"
                                                    :checked="userStore.user?.recurly_subscription_state == 'none'"
                                                    :disabled="userStore.user?.recurly_subscription_state != 'none'"
                                                />
                                                <span>
                                                    <span v-if="userStore.user?.recurly_subscription_state == 'none'" class="avatar align-baseline">
                                                        <span class="avatar-status-offline"></span>
                                                    </span>
                                                    None
                                                </span>
                                            </label>
                                            <label
                                                class="btn btn-outline-primary"
                                                :class="{ active: userStore.user?.recurly_subscription_state == 'active' }"
                                            >
                                                <input
                                                    type="radio"
                                                    name="radio_options"
                                                    id="radio_option2"
                                                    :checked="userStore.user?.recurly_subscription_state == 'active'"
                                                    :disabled="userStore.user?.recurly_subscription_state != 'active'"
                                                />
                                                <span>
                                                    <span v-if="userStore.user?.recurly_subscription_state == 'active'" class="avatar align-baseline">
                                                        <span class="avatar-status-online"></span>
                                                    </span>
                                                    Active
                                                </span>
                                            </label>
                                            <label
                                                class="btn btn-outline-danger"
                                                :class="{ active: userStore.user?.recurly_subscription_state == 'expired' }"
                                            >
                                                <input
                                                    type="radio"
                                                    name="radio_options"
                                                    id="radio_option3"
                                                    :checked="userStore.user?.recurly_subscription_state == 'expired'"
                                                    :disabled="userStore.user?.recurly_subscription_state != 'expired'"
                                                />
                                                    <span v-if="userStore.user?.recurly_subscription_state == 'expired'" class="avatar align-baseline">
                                                        <span class="avatar-status-busy"></span>
                                                    </span>
                                                    Expired
                                            </label>
                                        </div>
                                    </div>
                                    <h5 class="card-title text-primary text-center mb-0">Contact Information</h5>
                                    <profile></profile>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-7 col-md-7 col-sm-12 match-height">
                            <div class="card border-primary border-darken-1">
                                <div class="card-header d-flex justify-content-between pb-2">
                                    <div class="card-title">
                                        <h5 class="m-0 me-2 card-title text-center text-primary">Credit Monitoring Service</h5>
                                        <small class="text-muted text-center">1 Click Import</small>
                                    </div>
                                </div>
                                <client-report-form></client-report-form>
                            </div>
                        </div>
                    </div>
                    <div class="row match-height">
                        <div class="col-lg-4 col-md-4 col-12 mx-auto">
                            <lincence-state-id></lincence-state-id>
                        </div>
                        <div class="col-lg-4 col-md-4 col-12 mx-auto">
                            <social-security-card-upload></social-security-card-upload>
                        </div>
                        <div class="col-lg-4 col-md-4 col-12 mx-auto">
                            <address-verification-upload></address-verification-upload>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import PowerOfAttorney from "./PowerOfAttorney.vue"
    import { useClientStore } from "../../stores/ClientStore.js";
    import { useUserStore } from "../../stores/UserStore.js";
    export default {
        components: {
            PowerOfAttorney
        },
        setup(){
            return{
                clientStore : useClientStore(),
                userStore : useUserStore()
            }
        },
        mounted(){
            if(_.isEmpty(this.userStore.user.id)){
                this.userStore.fetchUser();
            }
        },
        methods:{
        }
    }
</script>
